import React from "react";
import { cn } from "../lib/utils";

const ViewToggle = ({ options = [], value, onChange, className = "", size = "sm", variant = "default" }) => {
  const sizeClasses = {
    sm: "px-2 py-1 text-xs",
    md: "px-3 py-1.5 text-sm",
    lg: "px-4 py-2 text-base",
  };

  const containerBase =
    variant === "unstyled" ? "inline-flex rounded-lg gap-1" : "inline-flex bg-gray-100 rounded-lg p-1";

  return (
    <div className={cn(containerBase, className)}>
      {options.map(option => (
        <button
          key={option.value}
          onClick={() => onChange(option.value)}
          className={cn(
            "rounded-md transition-all duration-200 font-medium",
            sizeClasses[size],
            value === option.value
              ? "bg-white text-gray-900 shadow-sm border border-gray-200"
              : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default ViewToggle;
